import { combineReducers } from "redux";
import type { Reducer } from "redux";
import { persistReducer } from "redux-persist";

import type { ReduxState } from "@dashboard/types/reduxState";

import {
  dashboardAppPersistConfig,
  dashboardAppReducer,
} from "./dashboardReducer";
// App reducers
import { dishReducer } from "./dishReducer";
import { dishViewedReducer } from "./dishViewedReducer";
import { errorReducer } from "./errorReducer";
import { locationReducer } from "./locationReducer";
import { menuFavoritesReducer } from "./menuFavoritesReducer";
import { menuReducer } from "./menuReducer";
import { menuUrlV2Reducer } from "./menuUrlV2Reducer";
import { productReducer } from "./productReducer";
import { resolvedEdiblesReducer } from "./resolvedEdiblesReducer";
import {
  restaurantReducer,
  restaurantReducerPersistConfig,
} from "./restaurantReducer";
import { supplierReducer } from "./supplierReducer";
import { termsAcceptanceReducer } from "./termsAcceptanceReducer";
import { themeReducer } from "./themeReducer";

export const rootReducer = ({ usePersist }: { usePersist: boolean }) =>
  combineReducers({
    dish: dishReducer,
    product: productReducer,
    resolvedEdibles: resolvedEdiblesReducer,
    menu: menuReducer,
    restaurant: (usePersist
      ? persistReducer(restaurantReducerPersistConfig, restaurantReducer)
      : restaurantReducer) as Reducer<ReduxState["restaurant"]>,
    location: locationReducer,
    termsAcceptance: termsAcceptanceReducer,
    supplier: supplierReducer,
    menuUrlV2: menuUrlV2Reducer,
    theme: themeReducer,
    error: errorReducer,
    menuFavorites: menuFavoritesReducer,
    dishViewed: dishViewedReducer,
    dashboardApp: (usePersist
      ? persistReducer(dashboardAppPersistConfig, dashboardAppReducer)
      : dashboardAppReducer) as Reducer<ReduxState["dashboardApp"]>,
  }) as Reducer<ReduxState>;
